import React, { Component } from 'react';
// import Posibles from "./../listaRevistas";
import { Image, Grid, Row } from 'react-bootstrap';
// import Contenido from "./tablaContenidoItem";
import './styles.css';
import Data from './revistasData';
import { Link } from 'react-router-dom';
import NotFound from '../../components/notFound';

var contentTable = [];

export default class NumberDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.routeParam = this.props.match.params;
  }
  componentWillMount() {
    contentTable = this.issue() ? this.issue().revistas : [];
  }
  issue() {
    const type = Data[this.routeParam.type];
    return (type && type[this.routeParam.numero]) || null;
  }
  componentWillReceiveProps(np) {
    console.log(np);
    if (JSON.stringify(np.match.params) !== JSON.stringify(this.routeParam)) {
      this.routeParam = np.match.params;
    }
  }
  renderColumns() {
    var tmpEle = [];
    for (let i = 0; i < contentTable.length; i++) {
      tmpEle.push(
        <li key={contentTable[i].nombre}>
          <div>
            <p style={{ color: 'white', fontSize: '16pt' }}>{contentTable[i].nombre}</p>
            <p style={{ color: 'white', fontSize: '14pt' }}>
              <i>{contentTable[i].autor}</i>
            </p>
            <Row>
              <a
                href={contentTable[i].pdfLocation}
                download
                style={{
                  border: 'none',
                  backgroundColor: 'transparent',
                  display: 'inline-block',
                }}
              >
                <Image
                  src={require('../../img/linkDownload.png')}
                  style={{
                    display: 'block',
                    height: 50,
                  }}
                  responsive
                />
              </a>
              <Link to={contentTable[i].location} style={{ display: 'inline-block', marginLeft: 50 }}>
                <Image
                  src={require('../../img/pdfIcon.png')}
                  style={{
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    display: 'block',
                    height: 50,
                  }}
                  responsive
                />
              </Link>
            </Row>
          </div>
        </li>
      );
      // if (
      //   contentTable[i * 3 + 0] !== undefined &&
      //   contentTable[i * 3 + 1] !== undefined &&
      //   contentTable[i * 3 + 2] !== undefined
      // ) {
      //   tmpEle.push(
      //     <Row bsClass="row revistaItemMargin">
      //       <Col xs={12} md={4}>
      //         <Contenido data={contentTable[i * 3 + 0]} />
      //       </Col>
      //       <Col xs={12} md={4}>
      //         <Contenido data={contentTable[i * 3 + 1]} />
      //       </Col>
      //       <Col xs={12} md={4}>
      //         <Contenido data={contentTable[i * 3 + 2]} />
      //       </Col>
      //     </Row>
      //   );
      // } else if (
      //   contentTable[i * 3 + 0] !== undefined &&
      //   contentTable[i * 3 + 1] !== undefined
      // ) {
      //   tmpEle.push(
      //     <Row bsClass="row revistaItemMargin">
      //       <Col xs={12} md={4}>
      //         <Contenido data={contentTable[i * 3 + 0]} />
      //       </Col>
      //       <Col xs={12} md={4}>
      //         <Contenido data={contentTable[i * 3 + 1]} />
      //       </Col>
      //     </Row>
      //   );
      // } else if (contentTable[i * 3 + 0] !== undefined) {
      //   tmpEle.push(
      //     <Row bsClass="row revistaItemMargin">
      //       <Col xs={12} md={4}>
      //         <Contenido data={contentTable[i * 3 + 0]} />
      //       </Col>
      //     </Row>
      //   );
      // }
    }

    return tmpEle.map((item, index) => {
      return item;
    });
  }
  render() {
    if (!this.issue()) return <NotFound />;
    return (
      <div className="navMargin" style={{ height: '100%' }}>
        <section
          style={{
            paddingTop: '2%',
            backgroundColor: '#352a35',
            display: 'flex',
            flexDirection: 'column',
            height: 'auto',
            minHeight: '100%',
          }}
        >
          <p
            style={{
              color: 'white',
              textAlign: 'center',
              fontSize: '60pt',
              fontWeight: 'Bold',
            }}
          >
            {Data[this.routeParam.type][this.routeParam.numero].title}
          </p>
          <Image
            src={require('../../img/lineRevistas.png')}
            style={{
              marginLeft: 'auto',
              marginRight: 'auto',
              display: 'block',
              marginTop: 20,
              marginBottom: 20,
            }}
            responsive
          />
          <div className="container">
            <p style={{ color: 'white', fontSize: '18pt' }}>{this.routeParam.type}</p>
            {/* <p style={{ color: "white", fontSize: "16pt" }}>Descripción</p>
            <p
              style={{
                color: "white",
                fontSize: "14pt",
                textAlign: "justify"
              }}
              dangerouslySetInnerHTML={{
                __html:
                  Data[this.routeParam.type][this.routeParam.numero].description
              }}
            /> */}
            <p
              style={{
                color: 'white',
                fontSize: '18pt',
                marginTop: 50,
                marginBottom: 20,
              }}
            >
              Tabla de Contenidos
            </p>
          </div>
          <Grid style={{ marginBottom: 100 }}>{this.renderColumns()}</Grid>
        </section>
      </div>
    );
  }
  componentDidMount() {}
  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/views/revistas/numberDetail.js